import React from "react";
import { Card } from "../ui/Card";
import { OperatorActivityPanel } from "./OperatorActivityPanel";
import { type Operator } from "../../services/StorageService";

interface MembersPanelProps {
  operators: Operator[];
}

export const MembersPanel: React.FC<MembersPanelProps> = ({ operators }) => {
  return (
    <div className="flex flex-row gap-4 w-full h-full">
      <Card padding="md" className="overflow-auto w-full">
        <OperatorActivityPanel operators={operators} />
      </Card>
    </div>
  );
};
